import React, {useState, useEffect} from 'react'
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export const ReviewInsights = ({data, tab}) => {
    const [insightDetails, setInsightDetails] = useState({
        total: 0,
        open: 0,
        assigned: 0,
        completed: 0,
        overdue: 0,
        withinTargetDate: 0
    })

    useEffect(() => {
        let mounted = true;

        const getInsights = () => {
            let total = 0;
            let open = 0;
            let assigned = 0;
            let completed = 0;
            let overdue = 0;
            let withinTargetDate = 0;
            if(data.length > 0){
                total = data.length;
                open = data.filter(card => card.status === "open").length;
                if(tab === 'mycards' || tab === 'allcards' || tab === 'myteamscards'){
                    assigned = data.filter(card => card.status === "assigned").length;
                }
                if(tab === 'myactions' || tab === 'allactions' || tab === 'assignedactions'){
                    if (tab === 'allactions' || tab === 'assignedactions') {
                        const today = dayjs();
            
                        const newoverdue = data.filter(card => {
                            const dueDate = dayjs(card.dueDate, 'YYYY-MM-DD');
                            return (card.status === "assigned" || card.status === "reassigned") && dueDate.isBefore(today, 'day');
                        }).length;
            
                        const newwithinTargetDate = data.filter(card => {
                            const dueDate = dayjs(card.dueDate, 'YYYY-MM-DD');
                            return (card.status === "assigned" || card.status === "reassigned") && dueDate.isSameOrAfter(today, 'day');
                        }).length;
            
                        overdue = newoverdue;
                        withinTargetDate = newwithinTargetDate;
                    }
                    assigned = data.filter(card => card.status === "assigned" || card.status === "reassigned").length;
                    completed = data.filter(card => card.status === "completed").length;
                }
            }
            setInsightDetails({
                total,
                open,
                assigned,
                completed,
                overdue,
                withinTargetDate
            })
        }

        if (mounted) {
            getInsights()
        }

        return () => {
            mounted = false;
        }
    }, [data, tab])


    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: "100%",
                    padding: "8px",
                    paddingRight: "10px", 
                    flexWrap: "wrap",
                    gap: "8px"
                    
                }}
            >
                <div
                    style={{
                        textAlign: "right",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 14,
                        fontWeight: 600,
                        color: "black",
                        height: "100%",
                        backgroundColor: "#f3f3f3",
                        width: "120px",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 3px 0px rgb(0, 0, 0, .1)",
                    }}
                >
                    <span>TOTAL: </span>
                    <span
                        style={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "black",
                        }}
                    >
                        {insightDetails.total}
                    </span>
                </div>

                <div
                    style={{
                        textAlign: "right",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#FF0000",
                        height: "100%",
                        backgroundColor: "#eaeaea",
                        width: "100px",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 3px 0px rgb(0, 0, 0, .1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "8px",
                    }}
                >
                    <span>OPEN: </span>
                    <span
                        style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#FF0000"
                        }}
                    >
                        {insightDetails.open}
                    </span>
                </div>

                <div
                    style={{
                        textAlign: "right",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#C00000",
                        height: "100%",
                        backgroundColor: "#eaeaea",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 3px 0px rgb(0, 0, 0, .1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "8px",
                        paddingRight: "20px",
                        paddingLeft: "20px",
                    }}
                >
                    <span>ASSIGNED: </span>
                    <span
                        style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#C00000",
                            marginRight: (tab === 'allactions') ? "10px" : "0px",
                        }}
                    >
                        {insightDetails.assigned}
                    </span>
                    {(tab === 'allactions') && (
                        <>
                            <div
                                style={{
                                    textAlign: "right",
                                    fontSize: 10,
                                    fontWeight: 600,
                                    color: "#C00000",
                                    height: "100%",
                                    backgroundColor: "#f5eeee",
                                    borderRadius: "999px",
                                    boxShadow: "0px 2px 3px 0px rgb(0, 0, 0, .1)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "3px 10px",
                                    marginRight: "10px",
                                }}
                            >
                                <span>OVERDUE:&nbsp;</span>
                                <span
                                    style={{
                                        fontSize: 10,
                                        fontWeight: 700,
                                        color: "#C00000",
                                    }}
                                >
                                    {insightDetails.overdue}
                                </span>
                            </div>

                            <div
                                style={{
                                    textAlign: "right",
                                    fontSize: 10,
                                    fontWeight: 600,
                                    color: "#0F7A4A",
                                    height: "100%",
                                    backgroundColor: "#edf7f2",
                                    borderRadius: "999px",
                                    boxShadow: "0px 2px 3px 0px rgb(0, 0, 0, .1)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "3px 10px",
                                }}
                            >
                                <span>WITHIN TARGET:&nbsp;</span>
                                <span
                                    style={{
                                        fontSize: 10,
                                        fontWeight: 700,
                                        color: "#0F7A4A",
                                    }}
                                >
                                    {insightDetails.withinTargetDate}
                                </span>
                            </div>
                        </>
                    )}
                </div>

                
            </div>
        </>
    )
}